import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const AdminUsers = () => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
        Admin - Users Management
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Users management page - coming soon.
      </Typography>
    </Box>
  );
};

export default AdminUsers;